import { BrandDiamond } from "../BrandMark";

export default function LandingFooter() {
  return (
    <footer className="flex items-center justify-between gap-4 border-t pt-6 text-muted-foreground">
      <div className="flex items-center gap-2">
        <BrandDiamond />
        <span
          className="text-[15px] font-semibold text-ink2"
          style={{ fontFamily: "var(--font-serif)" }}
        >
          Eventera
        </span>
      </div>
      <div className="flex items-center gap-4 text-[13px]">
        {/* Static pages in public/, not routes: Google's OAuth verification
            requires the homepage to link its privacy policy. */}
        <a href="/privacy.html" className="hover:underline">
          Privacy
        </a>
        <a href="/terms.html" className="hover:underline">
          Terms
        </a>
        <span className="font-mono text-[11px] tabular-nums">
          © {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
}
